// extracted by mini-css-extract-plugin
module.exports = {"projectImg":"project-module--project-img--1KY0Y"};